module.exports = __webpack_public_path__ + "static/media/load-blue.4f268b49.svg";